import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import TradeDetail from "@/pages/TradeDetail";
import Ledger from "@/pages/Ledger";
import ProjectReport from "@/pages/ProjectReport";
import InvoiceCreate from "@/pages/InvoiceCreate";
import InvoiceView from "@/pages/InvoiceView";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import { Toaster } from "@/components/ui/sonner";

function RedirectIfAuthed({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return <Navigate to="/projects" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login"           element={<RedirectIfAuthed><Login /></RedirectIfAuthed>} />
          <Route path="/register"        element={<RedirectIfAuthed><Register /></RedirectIfAuthed>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password"  element={<ResetPassword />} />
          <Route path="/terms"           element={<Terms />} />
          <Route path="/privacy"         element={<Privacy />} />

          <Route path="/projects"           element={<ProtectedRoute><Layout><Projects /></Layout></ProtectedRoute>} />
          <Route path="/projects/:id"       element={<ProtectedRoute><Layout><ProjectDetail /></Layout></ProtectedRoute>} />
          <Route path="/projects/:id/report" element={<ProtectedRoute><Layout><ProjectReport /></Layout></ProtectedRoute>} />
          <Route path="/projects/:id/invoice/new" element={<ProtectedRoute><Layout><InvoiceCreate /></Layout></ProtectedRoute>} />
          <Route path="/invoices/:id" element={<ProtectedRoute><Layout><InvoiceView /></Layout></ProtectedRoute>} />
          <Route path="/trades/:id"         element={<ProtectedRoute><Layout><TradeDetail /></Layout></ProtectedRoute>} />
          <Route path="/ledger"             element={<ProtectedRoute><Layout><Ledger /></Layout></ProtectedRoute>} />

          <Route path="/" element={<Navigate to="/projects" replace />} />
          <Route path="*" element={<Navigate to="/projects" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
